import { Injectable } from '@angular/core';
import { AppError } from '@shared/bloc/errors';

@Injectable({
  providedIn: 'root',
})
export class DynamicScriptService {
  private readonly pending: { [key: string]: Promise<void> | undefined } = {};

  // Returns a Promise that loads the script
  loadDynamicScript(id: string, url: string, options?: { delay?: number; attrs: Record<any, any> }): Promise<void> {
    const cached = this.pending[id];
    if (cached) return cached;

    const promise = new Promise<void>((resolve, reject) => {
      const scriptElement = window.document.createElement('script');
      Object.keys(options?.attrs || {}).forEach((key) => {
        scriptElement.setAttribute(key, options?.attrs[key]);
      });
      scriptElement.onload = () => resolve();
      scriptElement.onerror = () => {
        delete this.pending[id];
        reject(new AppError([`Google Map Script '${id}' failed to load`]));
      };
      scriptElement.id = id;
      scriptElement.src = url;
      window.document.body.appendChild(scriptElement);
    });

    this.pending[id] = promise;
    return promise;
  }
}
